export const CONTACT = {
  name: "DOABA Diagnostics Laboratory",
  website: "doabalabs.com",
  websiteUrl: "https://doabalabs.com",
  phoneDisplay: "+91 89683 48800",
  phoneRaw: "+918968348800",
  whatsapp: "918968348800",
  email: "info@doabalabs.com",
  addressLines: ["Talwan Road", "Opposite Nangal Gate", "Phillaur", "Punjab 144410, India"],
  instagram: "https://www.instagram.com/doabadiagnosticslaboratory",
  instagramHandle: "@doabadiagnosticslaboratory",
  mapsLink: "https://maps.app.goo.gl/qhTDqxGRQfYzwxPE7?g_st=iw",
  mapsQuery: "Doaba Diagnostics Laboratory, Talwan Road, Opposite Nangal Gate, Phillaur, Punjab 144410",
  googleReviewsUrl: "https://maps.app.goo.gl/qhTDqxGRQfYzwxPE7?g_st=iw",
  hours: [
    { day: "Monday – Saturday", time: "7:00 AM – 7:00 PM" },
    { day: "Sunday", time: "7:00 AM – 2:00 PM" },
  ],
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg || "Hello DOABA Diagnostics, I would like to book a test.")}`;

export const mailLink = `mailto:${CONTACT.email}`;

export const SERVICES = [
  { name: "Complete Blood Count (CBC)", icon: "Droplets", tags: ["cbc", "blood", "complete blood count"] },
  { name: "Blood Sugar", icon: "Activity", tags: ["sugar", "glucose", "diabetes"] },
  { name: "Diabetes Profile", icon: "LineChart", tags: ["diabetes", "sugar", "profile"] },
  { name: "Liver Function Test", icon: "Layers", tags: ["liver", "lft"] },
  { name: "Kidney Function Test", icon: "Filter", tags: ["kidney", "kft", "renal"] },
  { name: "Thyroid Profile", icon: "Gauge", tags: ["thyroid", "tsh", "t3", "t4"] },
  { name: "Urine Test", icon: "FlaskConical", tags: ["urine", "routine"] },
  { name: "Vitamin D", icon: "Sun", tags: ["vitamin", "d", "vitamin d"] },
  { name: "Vitamin B12", icon: "Pill", tags: ["vitamin", "b12", "vitamin b12"] },
  { name: "Pregnancy Test", icon: "Baby", tags: ["pregnancy", "beta hcg"] },
  { name: "Hormone Test", icon: "Dna", tags: ["hormone", "testosterone", "estrogen"] },
  { name: "Dengue Test", icon: "Bug", tags: ["dengue", "fever", "ns1"] },
  { name: "Typhoid Test", icon: "Thermometer", tags: ["typhoid", "widal", "fever"] },
  { name: "Malaria Test", icon: "Bug", tags: ["malaria", "fever", "mp"] },
  { name: "Lipid Profile", icon: "HeartPulse", tags: ["lipid", "cholesterol", "triglycerides"] },
  { name: "HbA1c", icon: "LineChart", tags: ["hba1c", "sugar", "diabetes", "glycated"] },
  { name: "Electrolytes", icon: "Zap", tags: ["electrolytes", "sodium", "potassium"] },
  { name: "Covid Test", icon: "ShieldCheck", tags: ["covid", "rtpcr", "antigen"] },
  { name: "Home Sample Collection", icon: "Home", tags: ["home", "collection", "sample"] },
];

export const WHY_CHOOSE = [
  { title: "Accurate Results", icon: "Target" },
  { title: "Experienced Professionals", icon: "GraduationCap" },
  { title: "Modern Equipment", icon: "Microscope" },
  { title: "Fast Reports", icon: "Clock" },
  { title: "Affordable Prices", icon: "BadgeIndianRupee" },
  { title: "Home Collection", icon: "Home" },
  { title: "Trusted Laboratory", icon: "BadgeCheck" },
  { title: "Personalized Care", icon: "HeartHandshake" },
];

export const STATS = [
  { value: 5000, suffix: "+", label: "Patients Served" },
  { value: 100, suffix: "+", label: "Laboratory Tests" },
];

export const WELLNESS_PACKAGES = [
  {
    id: "wellness-1.1", name: "Wellness 1.1", tier: "Basic", icon: "HeartPulse",
    original: 1200, price: 1000, popular: false,
    tests: [
      "Complete Blood Count (CBC)", "ESR", "Glucose Sugar Test", "Uric Acid", "Calcium",
      "Liver Function Test (LFT) + GGT", "Kidney Function Test", "Electrolytes Test",
      "Lipid Profile", "Thyroid Profile (T3, T4, TSH)", "Urine Examination Routine",
    ],
  },
  {
    id: "wellness-1.2", name: "Wellness 1.2", tier: "Essential", icon: "ShieldPlus",
    original: 1560, price: 1300, popular: true,
    tests: [
      "Complete Blood Count (CBC)", "ESR", "HbA1c Test", "Glucose Sugar Test", "Uric Acid", "Calcium",
      "Liver Function Test (LFT) + GGT", "Kidney Function Test", "Electrolytes Test", "Lipid Profile",
      "Iron Profile Test", "Thyroid Profile (T3, T4, TSH)", "Urine Examination Routine",
    ],
  },
  {
    id: "wellness-1.3", name: "Wellness 1.3", tier: "Advanced", icon: "LineChart",
    original: 2160, price: 1800, popular: false,
    tests: [
      "Complete Blood Count (CBC)", "ESR", "HbA1c Test", "Glucose Sugar Test", "Uric Acid", "Calcium",
      "Liver Function Test (LFT) + GGT", "Kidney Function Test", "Electrolytes Test", "Lipid Profile",
      "Iron Profile Test", "Thyroid Profile (T3, T4, TSH)", "Urine Examination Routine",
      "Vitamin B12", "Vitamin D3 25 Hydroxy",
    ],
  },
  {
    id: "wellness-1.4", name: "Wellness 1.4", tier: "Premium", icon: "Gem",
    original: 2400, price: 2000, popular: false,
    tests: [
      "Complete Blood Count (CBC)", "ESR", "HbA1c Test", "Glucose Sugar Test", "Uric Acid", "Calcium",
      "Liver Function Test (LFT) + GGT", "Kidney Function Test", "Electrolytes Test", "Lipid Profile",
      "Iron Profile Test", "Thyroid Profile (T3, T4, TSH)", "Urine Examination Routine",
      "Vitamin B12", "Vitamin D3 25 Hydroxy", "Rheumatoid Factor (RA) Quantitative", "CRP Quantitative",
    ],
  },
];

export const VACANCIES = [
  { title: "Laboratory Technician", icon: "Microscope" },
  { title: "Phlebotomist", icon: "Syringe" },
  { title: "Reception Executive", icon: "Headset" },
  { title: "Sales Executive", icon: "TrendingUp" },
  { title: "Marketing Executive", icon: "Megaphone" },
  { title: "Business Development Executive", icon: "Briefcase" },
  { title: "Collection Staff", icon: "Truck" },
];

export const B2B_BENEFITS = [
  { title: "Fast Turnaround Time", icon: "Timer" },
  { title: "Accurate Reports", icon: "FileCheck" },
  { title: "Reliable Laboratory Partner", icon: "Handshake" },
  { title: "Bulk Testing", icon: "Layers" },
  { title: "Dedicated Support Team", icon: "Headset" },
  { title: "Home Sample Collection", icon: "Home" },
  { title: "Affordable Pricing", icon: "BadgeIndianRupee" },
  { title: "Long-Term Partnerships", icon: "Infinity" },
];
